import { Injectable } from '@angular/core';
import { DateInterval } from 'src/app/model/date-interval.model';
import { Observable } from 'rxjs';
import { createAuthorizationHeader } from 'src/app/utils/headers';
import { GlobalService } from 'src/app/global.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SigninService } from 'src/app/signin/signin.service';
import { TokenLutDto } from 'src/app/model/data-managemnt';

@Injectable({
  providedIn: 'root'
})
export class AlertManagementService {

  constructor(private signinService : SigninService,
    private _http: HttpClient, 
    private globalService:GlobalService) { }

  getNotifications(dateInterval: DateInterval): Observable<any> {

    let headers = createAuthorizationHeader();
    return this._http.post( this.globalService.dns + 'alerts/notifications/'+this.signinService.isRootAdmin()+"/"+this.signinService.getUserId(), dateInterval, {headers: headers});
  }

  add(tokenLutDto: TokenLutDto) {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + 'tokenLut/update ', tokenLutDto, { headers: headers });
  }

 getNotificationsByIdDeviceType(idDevice: number, type: string, dateInterval: DateInterval): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http.post( this.globalService.dns + 'alerts/notificationsdetails/'+idDevice, {dateInterval, type}, {headers: headers});
  }
}
